export default function setupArticlesSearch() {
  const dropdowns = document.querySelectorAll('[data-articles-category-dropdown]');

  if (!dropdowns.length) {
    return;
  }

  dropdowns.forEach((dropdown) => {
    const label = dropdown.querySelector('[data-articles-category-label]');

    dropdown.querySelectorAll('input[type="radio"]').forEach((input) => {
      input.addEventListener('change', () => {
        if (!(input instanceof HTMLInputElement) || !input.checked || !label) {
          return;
        }

        label.textContent = input.nextElementSibling?.textContent?.trim() || 'All categories';
        dropdown.removeAttribute('open');
      });
    });
  });

  document.addEventListener('click', (event) => {
    dropdowns.forEach((dropdown) => {
      if (!dropdown.hasAttribute('open') || dropdown.contains(event.target)) {
        return;
      }

      dropdown.removeAttribute('open');
    });
  });
}
